module.exports = __webpack_public_path__ + "static/img/M2-S-351-1.c59e5bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module2/M2-S-351-1.png
// module id = 680
// module chunks = 0